import { createFileRoute } from '@tanstack/react-router';
import { ErrorState } from '@/components/domain/ErrorState';
import { scanDetailOptions } from '@/features/scans/api';
import { ScanDetailPage } from '@/features/scans/ScanDetailPage';
import { ScanDetailSearch } from '@/lib/search-schemas';

export const Route = createFileRoute('/_auth/scans/$id')({
  validateSearch: ScanDetailSearch,
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(scanDetailOptions(params.id)),
  // 404 ou panne : `ErrorState` dans le shell, « Réessayer » relance le loader.
  errorComponent: ({ error, reset }) => <ErrorState error={error} onRetry={reset} />,
  component: ScanDetailPage,
});
